import { call, delay, put, takeLatest } from "redux-saga/effects";
import { TICKET_API_URL } from "utils/constants";
import { handleApiError } from "utils/errorHandler";
import { request } from "utils/request";
import { fetchTicketsByIds } from "../../Tickets/redux/saga";
import { ITickets } from "../../Tickets/types";
import { ticketGroupsActions } from "../../Tickets/redux/slice";
import { backlogActions } from "../redux/slice";
import { PlanningViewBy } from "../types";

export function* fetchBacklogsPlanningRequest(actions: {
  payload: { boardId: string; viewBy: PlanningViewBy; skipLoading?: boolean };
}) {
  try {
    const { boardId, viewBy, skipLoading } = actions.payload;
    if (!skipLoading) {
      yield delay(500);
      yield put(backlogActions.setIsLoading(true));
    }
    const requestURL = `${TICKET_API_URL}board/planning/backlog/${boardId}?viewBy=${viewBy}`;
    const options = {
      method: "GET",
    };
    const { data, err } = yield call(request, requestURL, options);
    yield put(backlogActions.setIsLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }
    yield put(backlogActions.setPlanningItems(data?.data));
  } catch (err) {
    yield put(backlogActions.setIsLoading(false));
    handleApiError(err);
  }
}

export function* fetchPlanningFilterTicketsRequest(action: {
  payload: { tileId: string; ticketIds: string[] };
}) {
  const { tileId, ticketIds } = action.payload;

  try {
    if (!ticketIds.length) {
      yield put(
        backlogActions.setSelectedPlanningTile({ id: tileId, ticketIds: [] }),
      );
      yield put(backlogActions.setPlanningFilterLoading(false));
      return;
    }

    const tickets: ITickets[] | null = yield call(
      fetchTicketsByIds,
      ticketIds,
    );

    if (tickets === null) return;

    const newTicketsMap: Record<string, ITickets> = {};
    tickets.forEach((ticket) => {
      newTicketsMap[ticket._id] = ticket;
    });

    yield put(ticketGroupsActions.updateTicketCache(newTicketsMap));
    yield put(
      backlogActions.setSelectedPlanningTile({ id: tileId, ticketIds }),
    );
  } catch (err) {
    handleApiError(err);
  } finally {
    yield put(backlogActions.setPlanningFilterLoading(false));
  }
}

export function* backlogSaga() {
  yield takeLatest(
    backlogActions.fetchBacklogsPlanning,
    fetchBacklogsPlanningRequest,
  );
  yield takeLatest(
    backlogActions.fetchPlanningFilterTickets,
    fetchPlanningFilterTicketsRequest,
  );
}
